import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";
import { PaymentIntervalWithoutCustom2 } from "@/stores/downgrade-store";
import { ISimplePurchasePlan } from "@/types/subscription.types";
import { useState } from "react";
import UpgradeStepsDialog from "./upgrade-steps";

type Props = {
  subscriptionId: string;
  plan: ISimplePurchasePlan;
  className?: string;
  currentInterval: PaymentIntervalWithoutCustom2;
};

const UpgradePlanDialog = (props: Props) => {
  const [open, setOpen] = useState(false);
  const [upgradeDialogOpen, setUpgradeDialogOpen] = useState(false);

  const handleCancel = () => {
    setOpen(false);
  };

  const handleComplete = () => {
    setOpen(false);
    setUpgradeDialogOpen(false);
    // In a real app, you would refresh the subscription data here
  };

  return (
    <>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button variant="outline" className={cn(props?.className)}>
            Upgrade Plan
          </Button>
        </DialogTrigger>
        <DialogContent className="sm:max-w-md">
          <div className="text-center">
            <div className="pb-6 pt-5">
              <h2 className="text-xl font-semibold mb-2">Upgrade Your Plan</h2>
              <p className="text-muted-foreground">
                Choose how you want to enhance your subscription
              </p>
            </div>

            <div className="flex flex-col gap-2">
              <Button
                className="w-full"
                onClick={() => {
                  setOpen(false);
                  setUpgradeDialogOpen(true);
                }}
              >
                Continue to Upgrade
              </Button>

              <Button variant="outline" onClick={handleCancel}>
                Cancel
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <UpgradeStepsDialog
        open={upgradeDialogOpen}
        onOpenChange={setUpgradeDialogOpen}
        onComplete={handleComplete}
        currentPlan={props.plan}
        subscriptionId={props.subscriptionId}
        currentInterval={props.currentInterval}
      />
    </>
  );
};

export default UpgradePlanDialog;
